import React from 'react'
import EnsembleItem from '../EnsembleItem'

const EnsemblesList = ({ ensembles }) => {
  return ensembles.map(ensemble => <EnsembleItem ensemble={ ensemble } />)
}

export default EnsemblesList
